import React from 'react';
interface MarqueeProps {
  text: string;
  bgColor?: string;
  textColor?: string;
}
export function Marquee({
  text,
  bgColor = 'bg-brand-terracotta',
  textColor = 'text-white'
}: MarqueeProps) {
  // Duplicate text to ensure smooth infinite scrolling
  const repeatedText = Array(10).fill(text).join(' • ');
  return <div className={`w-full overflow-hidden py-4 ${bgColor} border-y border-white/10 relative z-20`} data-id="element-173">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-174">
        <span className={`text-xs md:text-sm font-medium tracking-[0.3em] uppercase ${textColor} px-4`} data-id="element-175">
          {repeatedText}
        </span>
        <span className={`text-xs md:text-sm font-medium tracking-[0.3em] uppercase ${textColor} px-4`} data-id="element-176">
          {repeatedText}
        </span>
      </div>
    </div>;
}